import gql from 'graphql-tag'

import { Mutation } from '../../types-graphql'

export type TDataDownloadCourseUsersMonitoring = Pick<
  Mutation,
  'downloadCourseUsersMonitoring'
>
export const DOWNLOAD_COURSE_USERS_MONITORING = gql`
  mutation ($input: DownloadCourseUsersMonitoringInput!) {
    downloadCourseUsersMonitoring(input: $input) {
      url
      hasNextPage
    }
  }
`
